import 'slick-carousel';


const $slickSlider = $('.activities');
const settings = {
    dots: true,
    arrows: false,
    slidesToShow: 3,
    infinite: true,
    responsive: [{
        breakpoint: 998,
        settings: {
            slidesToShow: 2,
        }
    }],
    responsive: [{
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
        }
    }],
    appendDots: $('.activities')
};

window.addEventListener('load', () => {
    if (window.innerWidth < 1200) {
        $slickSlider.slick(settings);
    }

    return false;
});


const debouncedSlider = _.debounce( () => {
    if (window.innerWidth > 1200) {
        if ($slickSlider.hasClass('slick-initialized')) {
            $slickSlider.slick('unslick');
        }
    } else if (window.innerWidth < 1200) {
        if (!$slickSlider.hasClass('slick-initialized')) {
            return $slickSlider.slick(settings);
        }

        return false;
    }

    return false;
}, 300);

window.addEventListener('resize', debouncedSlider);
